import script from "./Head.vue?vue&type=script&lang=ts&setup=true"
export * from "./Head.vue?vue&type=script&lang=ts&setup=true"

import "./Head.vue?vue&type=style&index=0&id=7bcb5f3c&lang=scss"

const __exports__ = script;

export default __exports__